import { FC } from "react";

import { ViewHandlingPanel } from "@ryde/controls";

export const NotificationsCustomHeaderRight: FC = () => {
  return <ViewHandlingPanel />;
};
